import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import { axiosPost, axiosGet } from "../../react_axios/Axios"
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { get_aside_details_action } from '../../actions/bookingDetails_action/bookingDetailsAsideAction/bookingDetailsAside_action';
import { fill_action } from '../../actions/fillList_action';
import { data } from 'jquery';

class BookingDetailsAside extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userId: '',
            centerID: '',
            centerName: '',
            centerAddress1: '',
            centerAddress2: '',
            centerCity: '',
            centerContact: '',
            centerPics: []
        }
        this.getbookingDetailsAside = this.getbookingDetailsAside.bind(this)
    }

    componentDidMount() {
        console.log('aside', this.props)
        this.setState({
            userId: sessionStorage.getItem('userId') == '' || sessionStorage.getItem('userId') == null ? '' : sessionStorage.getItem('userId'),
            centerID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : sessionStorage.getItem('CenterID')
        })

        setTimeout(() => {
            this.getbookingDetailsAside()
        }, 200);

    }

    getbookingDetailsAside() {
        const { centerContact, userId, centerID, centerAddress, centerCity, centerName, centerPics } = this.state
        this.props
            .get_aside_details_action((userId == '' || userId == null) ? null : userId, (centerID == '' || centerID == null) ? null : centerID).then((data) => {
                console.log(data)
                if (data.data[0].length != 0) {
                    this.setState({ centerContact: data.data[0].Contact })
                    this.setState({ centerAddress2: data.data[0].AddressLine2 })
                    this.setState({ centerAddress1: data.data[0].AddressLine1 })
                    this.setState({ centerCity: data.data[0].CityName })
                    this.setState({ centerName: data.data[0].Name })
                    setTimeout(() => {
                        if (data.data[0].Filepath != null && data.data[0].Filepath != '') {
                            this.setState({ centerPics: data.data[0].Filepath.split(',') })
                        }
                    }, 200);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    render() {
        const { centerContact, centerID, centerAddress1, centerAddress2, centerName, centerCity, centerPics } = this.state
        return (

            <>
                <div class="col-md-3">
                    <div style={{ position: "relative" }}>
                        <div class="sticky-left-side-div" data-toggle="affix">
                            {/* {console.log(centerPics)} */}
                            {centerPics.length &&
                                <OwlCarousel items={1} loop nav>
                                    {centerPics.map((data) => (
                                        <div class="item">
                                            <img alt="" style={{ width: '105%', height: '300px', objectFit: 'cover', overflow: 'hidden' }} title="" src={data} class="img" />
                                        </div>
                                    ))}
                                </OwlCarousel>}


                            <div class="info-box">
                                <div class="margin-l-20 margin-r-20 vendor-info bg-white radius">
                                    <div class="">
                                        <div class="frow f-space-between">
                                            <div class="fcol">
                                                <div class="vendor-details frow"><h1 class="h4 text-bold pre-wrap">{centerName}</h1></div>
                                                <div class="vendor-address d-flex margin-t-10 frow">
                                                    <div class="addr-left margin-r-5"><i class="fa fa-map-marker h6"></i></div>
                                                    <div class="addr-right">
                                                        <h6 class="text-secondary h6 frow v-center">
                                                            <span>{centerAddress1}, {centerAddress2}, {centerCity}</span>
                                                        </h6>
                                                        <p class="text-tertiary"></p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <a class="fcol align-fe" href="#">
                                            <span class="StarRating center rating-5 h4 large"><i class="fa fa-star margin-r-5"></i>5.0</span>
                                            <h6 class="h6 review-cnt nowrap">119<br />reviews</h6>
                                        </a> */}
                                        </div>
                                        <div class="frow fcol">
                                            <h6 class="green h6 pointer padding contact_text"><i class="fa fa-phone margin-r-5"></i>Contact: 8591951769</h6>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { get_aside_details_action })(BookingDetailsAside));